import {
  addDateOnlyDays,
  differenceInDateOnlyDays,
  positiveModulo,
  type DateOnly,
} from "./date-only";
import {
  MAIN_TEAMS,
  type MainTeam,
  type SchedulePattern,
  type Shift,
} from "./domain-types";

export const SHIFT_ANCHOR_DATE: DateOnly = "2026-01-12";
export const SHIFT_CYCLE_LENGTH = 32;

export const SHIFT_PATTERNS = {
  A1: ["SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF"],
  A2: ["SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF"],
  A3: ["OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF"],
  A4: ["SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF"],

  B1: ["OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH"],
  B2: ["OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH"],
  B3: ["OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH"],
  B4: ["OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH"],

  C1: ["GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE"],
  C2: ["GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE"],
  C3: ["GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE"],
  C4: ["GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE"],

  D1: ["OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF"],
  D2: ["OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE"],
  D3: ["OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE"],
  D4: ["OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","OFF","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","SABAH","SABAH","OGLE","OGLE","GECE","GECE","OFF","OFF","OFF","SABAH","OGLE","OGLE","GECE","GECE"],
} as const satisfies Readonly<Record<SchedulePattern, readonly Shift[]>>;

export const MAIN_TEAM_SHIFT_PATTERNS = {
  A: ["SABAH", "SABAH", "OGLE", "OGLE", "GECE", "GECE", "OFF", "OFF"],
  B: ["OGLE", "OGLE", "GECE", "GECE", "OFF", "OFF", "SABAH", "SABAH"],
  C: ["GECE", "GECE", "OFF", "OFF", "SABAH", "SABAH", "OGLE", "OGLE"],
  D: ["OFF", "OFF", "SABAH", "SABAH", "OGLE", "OGLE", "GECE", "GECE"],
} as const satisfies Readonly<Record<MainTeam, readonly Shift[]>>;

export function getShiftCycleIndex(date: DateOnly): number {
  return positiveModulo(differenceInDateOnlyDays(date, SHIFT_ANCHOR_DATE), SHIFT_CYCLE_LENGTH);
}

export function getShiftForPattern(pattern: SchedulePattern, date: DateOnly): Shift {
  const shift = SHIFT_PATTERNS[pattern][getShiftCycleIndex(date)];
  if (!shift) throw new RangeError("Vardiya döngüsü hesaplanamadı.");
  return shift;
}

export const getPersonalShift = getShiftForPattern;

export function getMainTeamShift(team: MainTeam, date: DateOnly): Shift {
  const index = positiveModulo(differenceInDateOnlyDays(date, SHIFT_ANCHOR_DATE), 8);
  const shift = MAIN_TEAM_SHIFT_PATTERNS[team][index];
  if (!shift) throw new RangeError("Ana ekip vardiyası hesaplanamadı.");
  return shift;
}

export const getTeamShift = getMainTeamShift;

export function getTeamsForShift(date: DateOnly, shift: Shift): MainTeam[] {
  return MAIN_TEAMS.filter((team) => getMainTeamShift(team, date) === shift);
}

export interface ShiftWeek {
  team: MainTeam;
  startDate: DateOnly;
  endDate: DateOnly;
  firstOffDate: DateOnly;
  secondOffDate: DateOnly;
}

/** Returns the eight-day team block containing the requested date. */
export function getShiftWeek(team: MainTeam, date: DateOnly): ShiftWeek {
  let startDate = date;
  for (let offset = 0; offset < 8; offset += 1) {
    const candidate = addDateOnlyDays(date, -offset);
    const previous = addDateOnlyDays(candidate, -1);
    if (getMainTeamShift(team, candidate) === "SABAH" && getMainTeamShift(team, previous) === "OFF") {
      startDate = candidate;
      break;
    }
  }
  return {
    team,
    startDate,
    endDate: addDateOnlyDays(startDate, 5),
    firstOffDate: addDateOnlyDays(startDate, 6),
    secondOffDate: addDateOnlyDays(startDate, 7),
  };
}

export function getNextNonOffShift(
  pattern: SchedulePattern,
  afterDate: DateOnly,
): { date: DateOnly; shift: Exclude<Shift, "OFF"> } {
  for (let offset = 1; offset <= SHIFT_CYCLE_LENGTH; offset += 1) {
    const date = addDateOnlyDays(afterDate, offset);
    const shift = getShiftForPattern(pattern, date);
    if (shift !== "OFF") return { date, shift };
  }
  throw new RangeError("Sonraki çalışma vardiyası bulunamadı.");
}

export interface ApprovedShiftChange {
  date: DateOnly;
  shift: Exclude<Shift, "OFF">;
}

export function getEffectiveShiftForPattern(
  pattern: SchedulePattern,
  date: DateOnly,
  changes: readonly ApprovedShiftChange[] = [],
): Shift {
  return changes.find((change) => change.date === date)?.shift
    ?? getShiftForPattern(pattern, date);
}

export function getNextEffectiveNonOffShift(
  pattern: SchedulePattern,
  afterDate: DateOnly,
  changes: readonly ApprovedShiftChange[] = [],
): { date: DateOnly; shift: Exclude<Shift, "OFF"> } {
  for (let offset = 1; offset <= SHIFT_CYCLE_LENGTH; offset += 1) {
    const date = addDateOnlyDays(afterDate, offset);
    const shift = getEffectiveShiftForPattern(pattern, date, changes);
    if (shift !== "OFF") return { date, shift };
  }
  throw new RangeError("Sonraki etkin çalışma vardiyası bulunamadı.");
}
